<script>
  import {mapGetters} from 'vuex';
  import PageDataSidebar from '@/components/shared_components/page_data/PageDataSidebar';

  export default {
    extends: PageDataSidebar,
    computed: {
      ...mapGetters('FeatureFlagsStore', [
        'enablePoliceCertificates',
        'enableFolkeregister'
      ]),
      ...mapGetters('UserInfoStore', [
        'isBankIdVerificationSource',
        'isCourtTheme'
      ]),
      mobTitle() { return this.$gettext('Documents'); },
      navLinksList() {
        const config = [
          {
            condition: !this.isCourtTheme,
            links: [
              {title: this.$gettext('Documents'), route: {name: 'ServerDocuments'}},
              {title: this.$gettext('Signatures'), route: {name: 'ServerSignatures'}}
            ]
          },
          {
            condition: this.isBankIdVerificationSource && this.enableFolkeregister,
            links: [
              {title: this.$gettext('In-Person assignment compliance'), route: {name: 'ServerInPersonCompliance'}}
            ]
          },
          {
            condition: this.enablePoliceCertificates,
            links: [
              {title: this.$gettext('Police Certificate'), route: {name: 'ServerCertificates'}}
            ]
          }
        ];

        return config
          .filter((item) => item.condition)
          .flatMap((item) => item.links);
      }
    }
  };
</script>
